import React, { useEffect, useState } from "react";
import { useScan } from "../contexts/ScanContext";
import LogoutButton from "./LogoutButton";
import { BarChart3, GitBranch } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { isAdminUser } from "../utils/auth";
import ConnectGitHubCard from "./ConnectGitHubCard";

const Welcome = () => {
  const { goToDashboard, user, goToRepositories } = useScan();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    setIsAdmin(isAdminUser(user));
  }, [user]);

  const handleDashboardClick = async () => {
    await goToDashboard();
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col sm:items-center sm:justify-center sm:relative">
      {/* Stacks above the hero on mobile; absolute overlay from `sm` up. */}
      <div className="flex items-center justify-end gap-3 p-4 sm:absolute sm:top-8 sm:right-8 sm:p-0 sm:gap-4">
        {isAdmin && (
          <button
            onClick={handleDashboardClick}
            className="flex items-center gap-2 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 px-4 py-2 rounded-lg transition-colors shadow-sm"
          >
            <BarChart3 className="w-5 h-5" />
            <span>Dashboard</span>
          </button>
        )}
        <LogoutButton />
      </div>
      <div className="flex-1 flex flex-col justify-center text-center w-full max-w-4xl mx-auto p-4 sm:p-8">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-3 sm:mb-4">Fenny</h1>
        <p className="text-lg sm:text-2xl text-gray-600 mb-6 sm:mb-8">Your First Product Security Hire</p>

        {/* Primary call to action: connecting GitHub is what makes the product work. */}
        <ConnectGitHubCard />

        <div className="flex flex-col items-center gap-3 mt-8">
          <button
            onClick={() => navigate("/repositories")}
            className="text-gray-600 hover:text-gray-900 underline flex items-center justify-center gap-2 min-h-[44px] px-2"
          >
            <GitBranch className="w-5 h-5" />
            <span>View existing repositories</span>
          </button>
          {isAdmin && (
            <button
              onClick={handleDashboardClick}
              className="text-gray-600 hover:text-gray-900 underline flex items-center justify-center gap-2 min-h-[44px] px-2"
            >
              <BarChart3 className="w-5 h-5" />
              <span>View dashboard</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
